import { IFieldDefinition, TFieldValidationResult } from './types';
import { getValidations } from './util';

export interface IValidateByRules<ValueType> {
  rules: NonNullable<IFieldDefinition['validate']>;
  value: ValueType;
}

/**
 * Este método toma un valor y unas reglas de validación
 * y ejecuta la validación correspondiente a dichas reglas.
 */
export function validateByRules<ValueType>({
  rules,
  value,
}: IValidateByRules<ValueType>): TFieldValidationResult {
  const validationResult = getValidations(rules).validate(value);
  return validationResult;
}
